module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_foilRosegoldHover-57ac5054c109222e02661f7eb461c6c3.jpg";